import { Box, Button, Checkbox, Collapse, Container, FormControl, FormControlLabel, Grid, IconButton, InputLabel, List, ListItem, ListItemText, MenuItem, Modal, Select, TextField, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as yup from 'yup';
import RtlProvider from "../../../Components/RtlProvider";
import customtheme from "../../../themes";
import { RiDeleteBin5Fill } from "react-icons/ri";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { TbEdit, TbPlaylistAdd } from "react-icons/tb";
import EnumMapper from "../../../EnumMapper";
import AddPackageEvent from "./AddPackageEvent";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import packageApi from "../../../api/packageApi";
import { ContextNotification, severitys } from "../../../App";
import EditPackageEvent from "./EditPackageEvents";
import { MdCalculate, MdCheck, MdClose, MdExpandLess, MdExpandMore, MdList, MdOutlineSearch, MdReviews } from "react-icons/md";


const EditNewPackageDetail = ({  PackageDetail, EditPackageDetail, Refresh }) => {

    const { open, setOpen } = useContext(ContextNotification);
    const [isloading, setIsloading] = useState(false);
    const [title, setTitle] = useState('');
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showError, setShowError] = useState(false);
    const customization = useSelector((state) => state.customization);
    const schema = yup.object().shape({
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

        resolver: yupResolver(schema),
    });

 

    useEffect(() => {
       resetForm();
    }, [PackageDetail]);

 
    const HandleChangeTitle = (event) => {
        setTitle(event.target.value);
    }
    const onSubmit = () => {

    }

    const AddDetail = () => {
       
        if (title === null) {
            setShowError(true);
        }
        else {
            const detaildata = {
                "title": title,
                "events": events,
            }
            EditPackageDetail(detaildata);
            resetForm();
        }
    }
    const resetForm = () => {
        setShowError(false);
        setTitle('');
        setEvents([]);
        setSelectedEvent(null);
        if (PackageDetail) {
            setTitle(PackageDetail.title);
            setEvents(PackageDetail.events);

        }
    }

    /////event
    const [showAddEvent, setShowAddEvent] = useState(false);
        const [showEditEvent, setShowEditEvent] = useState(false);
    const AddNewEvent = (eventData) => {
        var maxIndex = events.length > 0 ? Math.max(...events.map(a => { return a.index })) : 0;
        const newitem = {
            "index": maxIndex + 1,
            "value": eventData
        }
        setEvents([...events, newitem]);
        setShowAddEvent(false);
    }
 const LocalUpdate=(index,eventdata)=>{
const updateditem = {
            "index": index,
            "value": eventdata
        }
         setEvents([...events.filter((e)=>e.index!==index), updateditem]);

    }

    const RemoveEvent = (index) => {
            const a = events.filter((a) => a.index !== index);
            setEvents(a);   
    }
    const HandleEditEvent = () => {
        if (showEditEvent) {
            setShowEditEvent(false);
        }
        else {
            setShowEditEvent(true);
        }
    }
        const HandleAddEvent = () => {
        if (showAddEvent) {
            setShowAddEvent(false);         
        }
        else {
            setShowAddEvent(true);
        }

    }
 

    return (
        <>
            <ThemeProvider theme={customtheme(customization)}>
                <Container maxWidth={false} style={{ padding: 20 }}  >
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <RtlProvider>
                            <Grid container spacing={1} >

                                <Grid item md={12} xs={12}>
                                    <TextField label="عنوان مرحله سفر" margin="normal" value={title} onChange={(e) => HandleChangeTitle(e)} sx={{ width: '60%' }}></TextField>

                                    {(title!=='') && <Tooltip title="افزودن رویداد سفر"><IconButton edge="end" sx={{ mt: 3 }} aria-label="افزودن رویداد سفر" onClick={() => { HandleAddEvent(); }}>
                                        <TbPlaylistAdd color='#4a148c' size={24} />
                                    </IconButton>
                                    </Tooltip>}

                                   
                                    
                                    {(title!=='') && <Tooltip title="ویرایش رویدادهای سفر"><IconButton disabled={isloading} edge="end" sx={{ mt: 3 }} aria-label="ویرایش رویدادهای سفر" onClick={() => { HandleEditEvent(); }}>
                                        <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                                       {(showEditEvent)?<MdExpandLess  color='#4a148c' size={24} />:<MdExpandMore  color='#4a148c' size={24} />} 
                                    </IconButton>
                                    </Tooltip>}

                                </Grid>
                            </Grid>
                            {(showAddEvent)&&<AddPackageEvent Event={selectedEvent} AddPackageEvent={(data) => AddNewEvent(data)}/> }

                                   {(showEditEvent)&&<EditPackageEvent Events={events} Refresh={resetForm} IsLocal={true} LocalUpdate={(index,data)=>LocalUpdate(index,data)}  /> }
                            {(events?.length > 0) && <>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{
                                        fontSize: "16px",
                                        width: "10rem",
                                        height: "3rem",
                                    }}
                                    sx={{ mt: 1 }}
                                    onClick={() => { AddDetail() }}
                                >
                                    ویرایش مرحله سفر 
                                </Button>
                                {(showError) && <p className="error">{' عنوان مرحله سفر را وارد کنید'}</p>}

                            </>}
                        

                        </RtlProvider>
                    </form>
                 
                </Container>
            </ThemeProvider>
        </>

    );
}
export default EditNewPackageDetail;